module.exports = __webpack_public_path__ + "media/images/fondo_corona-195c0cd097bdab20d4f04a9e264590df.jpg";